// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.PROD 
    ? (import.meta.env.VITE_API_URL_PRODUCTION)
    : (import.meta.env.VITE_API_URL),
  ENDPOINTS: {
    AUTH: '/api/auth',
    PROJECTS: '/api/projects',
    USERS: '/api/users',
    PAYMENTS: '/api/payments',
    DONATIONS: '/api/donations',
    WITHDRAWALS: '/api/withdrawals',
    ADMIN: '/api/admin',
    LEADERBOARDS: '/api/leaderboards',
    DASHBOARD: '/api/dashboard'
  }
}

// Project Status Constants
export const PROJECT_STATUS = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  SUSPENDED: 'suspended'
}

// Donation Status Constants
export const DONATION_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded'
}

// Withdrawal Status Constants
export const WITHDRAWAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PROCESSED: 'processed'
}

// User Roles
export const USER_ROLES = {
  USER: 'user',
  PROJECT_OWNER: 'project_owner',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin'
}

// Project Categories
export const PROJECT_CATEGORIES = {
  MEDICAL: 'medical',
  EDUCATION: 'education',
  TECHNOLOGY: 'technology',
  ENVIRONMENT: 'environment',
  COMMUNITY: 'community',
  ARTS: 'arts'
}

// Funding For Options
export const FUNDING_FOR_OPTIONS = {
  PERSONAL: 'personal',
  APP_DEVELOPMENT: 'app_development',
  OTHERS: 'others'
}

// Campaign Duration Options
export const CAMPAIGN_DURATION = {
  THREE_DAYS: '3_days',
  SEVEN_DAYS: '7_days',
  TWO_WEEKS: '2_weeks',
  FOUR_WEEKS: '4_weeks',
  SIX_WEEKS: '6_weeks',
  THREE_MONTHS: '3_months'
}

// Default Funding Breakdown Categories
export const FUNDING_BREAKDOWN_CATEGORIES = [
  { category: 'Development', description: 'Core development costs' },
  { category: 'Marketing', description: 'Promotion and outreach' },
  { category: 'Operations', description: 'Day-to-day operations' },
  { category: 'Equipment', description: 'Tools and equipment' },
  { category: 'Legal', description: 'Legal and compliance costs' },
  { category: 'Miscellaneous', description: 'Other expenses' }
]

// Badge Levels
export const BADGE_LEVELS = {
  BRONZE: 'bronze',    // 100+ Pi donated
  SILVER: 'silver',    // 500+ Pi donated
  GOLD: 'gold',        // 1000+ Pi donated
  PLATINUM: 'platinum' // 5000+ Pi donated
}

// Commission Rate
export const COMMISSION_RATE = 0.0199 // 1.99%

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100
}

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp', 'video/mp4'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.webp', '.mp4']
}

// Validation Rules
export const VALIDATION = {
  USERNAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 30,
    PATTERN: /^[a-zA-Z0-9_]+$/
  },
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128
  },
  PROJECT_TITLE: {
    MIN_LENGTH: 10,
    MAX_LENGTH: 100
  },
  PROJECT_DESCRIPTION: {
    MIN_LENGTH: 50,
    MAX_LENGTH: 2000
  },
  FUNDING_GOAL: {
    MIN_AMOUNT: 10,
    MAX_AMOUNT: 1000000
  },
  DONATION: {
    MIN_AMOUNT: 1,
    MAX_AMOUNT: 10000
  }
}

// Time Constants
export const TIME = {
  PROJECT_APPROVAL_DEADLINE: 48 * 60 * 60 * 1000, // 48 hours in ms
  WITHDRAWAL_PROCESSING_DEADLINE: 24 * 60 * 60 * 1000, // 24 hours in ms
  CACHE_DURATION: {
    SHORT: 5 * 60 * 1000,      // 5 minutes
    MEDIUM: 30 * 60 * 1000,    // 30 minutes
    LONG: 24 * 60 * 60 * 1000  // 24 hours
  }
}

// Error Codes
export const ERROR_CODES = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  AUTHORIZATION_ERROR: 'AUTHORIZATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  DUPLICATE_ENTRY: 'DUPLICATE_ENTRY',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  TRANSACTION_FAILED: 'TRANSACTION_FAILED',
  FILE_UPLOAD_ERROR: 'FILE_UPLOAD_ERROR',
  RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR'
}

// Success Messages
export const SUCCESS_MESSAGES = {
  PROJECT_CREATED: 'Project submitted successfully! It will be reviewed within 48 hours.',
  PROJECT_UPDATED: 'Project updated successfully.',
  DONATION_COMPLETED: 'Thank you for your donation! Your contribution makes a difference.',
  WITHDRAWAL_REQUESTED: 'Withdrawal request submitted. It will be processed within 24 hours.',
  PROFILE_UPDATED: 'Profile updated successfully.',
  COMMENT_POSTED: 'Comment posted successfully.'
}

// Storage Keys for Frontend
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'crowblock_access_token',
  REFRESH_TOKEN: 'crowblock_refresh_token',
  USER_DATA: 'crowblock_user_data'
}

// Pi SDK Configuration
export const PI_SDK_CONFIG = {
  SCOPES: ['username', 'payments', 'wallet_address']
}
